import { Injectable, WritableSignal, signal } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { StandardPopupComponent } from 'src/app/shared/components/standard-popup/standard-popup.component';
import { cacheValue } from 'src/app/shared/service/general.service';
import { LocaleService } from 'src/app/shared/service/locale.service';
import { PopupService } from 'src/app/shared/service/popup.service';

@Injectable({
  providedIn: 'root',
})
export class VoucherCenterService {
  constructor(
    private bonusApi: BonusApi,
    private popup: PopupService,
    private localeService: LocaleService,
    private appService: AppService,
  ) {}

  /** 刷新非粘性 */
  _reloadNonSticky: WritableSignal<boolean> = signal(false);
  /** 缓存卡券的文案内容 */
  private cardContentBuffer: { [key: string]: Observable<{ content: string }> } = {};

  /** 非黏性卡券的活动编号 */
  nonStickyBonusTmpCode$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  /** 是否是当前非粘性活动 注册kyc 并且检查是否符合 kyc*/
  nonStickyWithKyc: WritableSignal<{
    bonusActivitiesNo: string;
    countryCheck: boolean | null;
  } | null> = signal(null);

  /**
   *  获取非粘性卡券文案
   *
   * @param params
   * @param params.code
   * @param params.isDeposit
   * @param params.category
   * @param params.isFreeSpin
   * @returns
   */
  public getNoneStickyDetail(params: {
    code: string;
    isDeposit: boolean;
    category: string;
    isFreeSpin?: boolean;
  }): Observable<{ content: string }> {
    const bufferKey = window.btoa(JSON.stringify(params));
    return (
      this.cardContentBuffer[bufferKey] ??
      ((this.cardContentBuffer[bufferKey] = this.bonusApi.getNoneStickyDetail(params).pipe(
        cacheValue(1000 * 60 * 10), //缓存10分钟
        map(x => x && this.newObj(x)),
      )),
      this.cardContentBuffer[bufferKey])
    );
  }

  private newObj(v: unknown) {
    return JSON.parse(JSON.stringify(v));
  }

  /** 非粘性检查 kyc */
  onNonStickyCheckPopup() {
    this.popup.open(StandardPopupComponent, {
      data: {
        type: 'warn',
        content: this.localeService.getValue('nonsticky_hint'),
        description: this.localeService.getValue('nonsticky_hint_msg'),
        buttons: [{ text: this.localeService.getValue('online_cs'), primary: true }],
        closeIcon: true,
        callback: () => {
          this.appService.toOnLineService$.next(true);
        },
      },
    });
  }

  onReset() {
    this.nonStickyWithKyc.set(null);
  }
}
